(() => {

  const SELECTOR = "[data-uf-trust-strip]";

  class UFTrustStrip {

    constructor(section) {

      if (!section) return;

      if (section.dataset.ufTrustInitialized === "true") {
        return;
      }

      this.section = section;
      this.track = section.querySelector("[data-uf-trust-track]");

      this.items = Array.from(
        section.querySelectorAll("[data-uf-trust-item]")
      );

      this.dots = Array.from(
        section.querySelectorAll("[data-uf-trust-dot]")
      );

      this.activeIndex = 0;

      this.raf = null;

      if (!this.track || !this.items.length) {
        return;
      }

      section.dataset.ufTrustInitialized = "true";

      this.handleScroll =
        this.handleScroll.bind(this);

      this.handleResize =
        this.handleResize.bind(this);

      this.bindEvents();

      this.updateActiveDot();

    }


    bindEvents() {

      this.track.addEventListener(
        "scroll",
        this.handleScroll,
        {
          passive: true
        }
      );


      this.dots.forEach((dot, index) => {

        dot.addEventListener(
          "click",
          () => {
            this.scrollToItem(index);
          }
        );

      });


      window.addEventListener(
        "resize",
        this.handleResize
      );

    }


    handleScroll() {

      if (this.raf) {
        cancelAnimationFrame(this.raf);
      }

      this.raf = requestAnimationFrame(() => {

        this.updateActiveDot();

      });

    }


    handleResize() {

      this.updateActiveDot();

    }


    getNearestIndex() {

      const trackRect =
        this.track.getBoundingClientRect();

      const trackCenter =
        trackRect.left +
        (trackRect.width / 2);

      let nearestIndex = 0;
      let nearestDistance = Infinity;


      this.items.forEach(
        (item, index) => {

          const itemRect =
            item.getBoundingClientRect();

          const itemCenter =
            itemRect.left +
            (itemRect.width / 2);

          const distance =
            Math.abs(
              itemCenter -
              trackCenter
            );


          if (distance < nearestDistance) {

            nearestDistance = distance;
            nearestIndex = index;

          }

        }
      );


      return nearestIndex;

    }


    updateActiveDot() {

      if (!this.dots.length) return;


      /*
        Desktop dots are hidden.
        Only calculate carousel position
        when mobile layout is active.
      */

      if (
        window.matchMedia(
          "(min-width: 750px)"
        ).matches
      ) {

        this.setActiveDot(0);

        return;

      }


      const nearest =
        this.getNearestIndex();


      this.setActiveDot(nearest);

    }


    setActiveDot(index) {

      this.activeIndex = index;


      this.dots.forEach(
        (dot, dotIndex) => {

          const active =
            dotIndex === index;


          dot.classList.toggle(
            "is-active",
            active
          );


          if (active) {

            dot.setAttribute(
              "aria-current",
              "true"
            );

          } else {

            dot.removeAttribute(
              "aria-current"
            );

          }

        }
      );

    }


    scrollToItem(index) {

      const item = this.items[index];

      if (!item) return;


      const target =
        item.offsetLeft
        -
        (
          this.track.clientWidth
          -
          item.clientWidth
        ) / 2;


      this.track.scrollTo({
        left: target,
        behavior: "smooth"
      });

    }

  }


  function initialize(scope = document) {

    const sections = [];


    if (scope.matches?.(SELECTOR)) {

      sections.push(scope);

    }


    if (scope.querySelectorAll) {

      sections.push(
        ...scope.querySelectorAll(
          SELECTOR
        )
      );

    }


    sections.forEach(
      section => {

        new UFTrustStrip(section);

      }
    );

  }


  if (
    document.readyState === "loading"
  ) {

    document.addEventListener(
      "DOMContentLoaded",
      () => initialize()
    );

  } else {

    initialize();

  }


  document.addEventListener(
    "shopify:section:load",
    event => {

      initialize(event.target);

    }
  );

})();